import ControlProps from '../../../mixins/ControlProps';
import { SelectProperty } from '../enums';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';
import { DEFAULT_NO_VALUE_OPTION } from '../constants';

const SelectProps = {
  props: {
    ...ControlProps.props,
    [SelectProperty.IsLoading]: InputProps.props[InputProperty.IsLoading],
    [SelectProperty.FillType]: InputProps.props[InputProperty.FillType],
    [SelectProperty.Options]: {
      default: () => ([]),
      type: Array,
    },
    [SelectProperty.Multiple]: {
      default: false,
      type: Boolean,
    },
    [SelectProperty.Filterable]: {
      default: false,
      type: Boolean,
    },
    [SelectProperty.NoValueOption]: {
      default: () => DEFAULT_NO_VALUE_OPTION,
      type: Object,
    },
    [SelectProperty.InputValue]: {
      default: '',
      type: String,
    },
    [SelectProperty.InputChangeHandler]: {
      default: () => () => {},
      type: Function,
    },
  },
};

export default SelectProps;
